import CloseIcon from "@mui/icons-material/Close";
import { Box, Fade, Modal, type SxProps, Typography, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import type React from "react";

export default function SimpleModal({
  open,
  children,
  disableClose,
  closeModal,
  title,
  innerSx,
  sx,
}: {
  open: boolean;
  children: React.ReactNode;
  closeModal?: () => void;
  footerSlot?: React.ReactNode;
  title?: string | React.ReactNode;
  sx?: SxProps;
  innerSx?: SxProps;
  disableClose?: boolean;
}) {
  const theme = useTheme();

  const handleClose = () => {
    if (disableClose) {
      return;
    }
    closeModal();
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      aria-hidden={!open}
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(8px)",
        zIndex: theme.zIndex.modal + 10,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            width: "600px",
            pb: 2,
            background: theme.palette.secondary.dark,
            borderRadius: "1rem",
            outline: "none !important",
            ...sx,
          }}
        >
          <Box sx={{ display: "flex", width: "100%", py: 1, px: 2 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h6" component="h2">
                <>{title}</>
              </Typography>
            </Box>
            <Box>
              <IconButton
                disabled={disableClose}
                size="small"
                aria-label="close"
                color="primary"
                onClick={(e) => handleClose()}
              >
                <CloseIcon role="img" />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              minHeight: "100px",
              height: "auto",
              maxHeight: "calc(100vh/1.5)",
              overflowY: "auto",
              padding: "0 16px",
              ...innerSx,
            }}
          >
            <>{children}</>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
